import React from "/vendor/react";
import PropTypes from "prop-types";

import uniqueId from "/lib/util/uniqueId";

class AnimatedLogo extends React.PureComponent {
  static propTypes = {
    style: PropTypes.object,
    size: PropTypes.number,
    color: PropTypes.string,
  };

  static defaultProps = {
    style: {},
    size: 100,
    color: "currentColor",
  };

  componentWillMount() {
    this._id = `AnimatedLogo-${uniqueId()}`;
  }

  render() {
    const { style, size, color } = this.props;

    const edge = 100;
    const strokeWidth = 0.14 * edge;

    const circle = animation => (
      <circle
        cx={edge / 2}
        cy={edge / 2}
        r={edge / 2 - strokeWidth}
        clipPath={`url(#${this._id}-outerClipPath)`}
      >
        <animate
          attributeType="XML"
          attributeName="r"
          from={strokeWidth / 2}
          to={edge / 2 - strokeWidth}
          dur="2s"
          repeatCount="indefinite"
          calcMode="spline"
          keySplines="0.5 0 1 0.5"
          {...animation}
        />
      </circle>
    );

    return (
      <svg
        style={style}
        width={size}
        height={size}
        viewBox={`0 0 ${edge} ${edge}`}
        fill="none"
      >
        <defs>
          <clipPath id={`${this._id}-outerClipPath`}>
            <rect width={edge} height={edge} />
          </clipPath>
        </defs>
        <g
          stroke={color}
          strokeWidth={strokeWidth}
        >
          {circle()}
          {circle({ begin: `-${2 / 3}s` })}
          {circle({ begin: `-${4 / 3}s` })}
        </g>
      </svg>
    );
  }
}

export default AnimatedLogo;
